import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Save Fred",
  "description": "",
  "published": "2007-04-10T00:00:00.000Z",
  "redirect_from": ["/blog/save-fred/swizec/237"],
  "categories": "funny, intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever operated on a fluffy bunny? How about a stuffed toy fluffy bunny?`}</p>
    <p>{`Is the answer no? Well now `}<a parentName="p" {...{
        "href": "http://www.10mg.nl/"
      }}>{`you can`}</a>{`! And it's really funny and amusing at that. Have to say I quite enjoyed this little flash game even though it's really a one shot deal and not something you could just keep playing over and over. It's still worth giving a go.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      